// extracted by mini-css-extract-plugin
export default {"pagination":"PagePagination_pagination__WC4uX"};